<template>
  <v-dialog v-model="dialog" max-width="80%" persistent>
      <v-card>
            <v-card-title class="pa-1">
                <v-col cols="12" class="pa-0 text-right">
                    <v-btn icon color="primary" @click="close()">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-col>
                <v-col cols="12" class="pa-0 text-center">
                    <h1>Histórico de Recurso</h1>
                </v-col>
            </v-card-title>
            
            <v-card-text class="py-0">
                <v-row>
        <v-col class="py-0 px-2" cols="12">
            <v-data-table
                dense
                :headers="headers"
                :items="lista"
                :page.sync="page"
                :items-per-page="10"
                @page-count="pageCount = parseInt($event, 10)"
                hide-default-footer
            >
                <template v-slot:item="props">
                    <tr>
                        <td>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <span v-bind="attrs" v-on="on" class="pr-2">
                                        <v-icon :color="colorList[props.item.status]" small>
                                            {{iconList[props.item.status] }}
                                        </v-icon>
                                    </span>
                                </template>
                                <span class="px-3 py-1 ma-0" style=" border: solid 1px #999; border-radius: 5px; background-color: #fff;">
                                    {{ labelList[props.item.status] }}
                                </span>
                            </v-tooltip>
                            {{ props.item.data_evento | formatDateHour }}
                        </td>
                        <td>
                            {{ props.item.identificador_prestador }}
                        </td>
                        <td>
                            <span v-if="!props.item.erro"> {{ props.item.descricao ? props.item.descricao : ''}} </span>
                            <span v-else style="color: #d0021b"> {{ props.item.descricao }} </span>
                        </td>
                    </tr>
                </template>
            </v-data-table>
        </v-col>
        <v-col class="pa-0" cols="12">
            <v-pagination class="no-box-shadow" v-model="page" :length="pageCount"></v-pagination>
        </v-col>
    </v-row>
            </v-card-text>

            <v-card-actions class="justify-center py-5">
                <v-btn
                    color="primary"
                    height="30px"
                    small
                    depressed
                    @click="close()"
                >Fechar
                </v-btn>
            </v-card-actions>
      </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment"
export default {

    data() {
        return {
            headers: [
                { text: "Data do evento", value: "data_evento", sortable: false },
                { text: "Ident.", value: "identificador_prestador", sortable: false },
                { text: "Evento", value: "evento", sortable: false },
            ],
            colorList:{
                executado: "success", 
                em_execucao: "warning",
                com_intercorrencia: "error"
                },
            iconList:{
                executado: "fa-check-circle", 
                em_execucao: "fas fa-exclamation-triangle",
                com_intercorrencia: "fas fa-exclamation-circle"
            },
            labelList:{
                executado: "Executado", 
                em_execucao: "Em execução",
                com_intercorrencia: "Com intercorrência"
            },
            page: 1,
            pageCount: 1
        }
    },
    filters: {
        formatDateHour(date) {
            return moment(date).format('L') + ' às ' + moment(date).format('LT') + 'h' 
        },
    },
    methods:{

    },
    props: {
        lista: Array,
        close: Function,
        dialog: Boolean,
    },
} 
</script>

<style>

</style>